import api from '@/apis/di/tempFixedAssetCategoryAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('fixedAssetCategoryTT23', api);
const state = {
  ...crud.state,
  _config: {
    table: 'temp_fixed_asset_category',
    field: {
      key: 'temp_fixed_asset_category_id',
      code: 'fixed_asset_category_code',
      name: 'fixed_asset_category_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
